﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IProfileImageFilter } from "@app/filters/profile-image.filter";
import { Dirs } from "@app/helpers/dirs";
import { ApiService } from "@app/services/api.service";
import { KbService } from "@app/services/kb.service";
import { UploadService } from "@app/services/upload.service";
import { IRootScope, eAlertType } from "@models";
import { events } from "@tools";
import { DialogService } from "@app/services/dialog.service";

export interface IAvatarSelectScope extends ng.IScope {
    ngModel: string;
    userId: number;
    imgPath: string;
    isEnabled: () => boolean;
    clear: () => void;
    click: () => void;
}

@NgComponent({
    token: Token.KbAvatarSelect,
    dependencies: [
        Token.KbService,
        Token.$RootScope,
        Token.UploadService,
        Token.$Filter,
        Token.ApiService,
        Token.DialogService,
    ]
})
export class KbAvatarSelect extends Directive {
    constructor(
        kbService: KbService,
        $rootScope: IRootScope,
        uploadService: UploadService,
        $filter: ng.IFilterService,
        apiService: ApiService,
        dialogService: DialogService,
    ) {
        super();
        this.replace = true;
        this.restrict = "E";
        this.scope = {
            ngModel: "=",
            userId: "="
        };
        this.template = Dirs.component("kb-avatar-select");

        this.link = (scope: IAvatarSelectScope, element, atts, ngModelController: ng.INgModelController) => {
            scope.isEnabled = () => {
                return !($(element).hasClass("disabled") || $(element).attr("disabled"));
            };

            scope.imgPath = (($filter as any)("profileImage") as IProfileImageFilter)(scope.ngModel);

            scope.clear = () => {
                apiService.users.clearProfileImage(scope.userId).then(user => {
                    scope.ngModel = user.imagePath;
                    scope.imgPath = user.imagePath;
                    if (scope.userId == $rootScope.user.id) {
                        $rootScope.$broadcast(events.avatarChanged, scope.ngModel);
                    }
                });
            };

            scope.click = () => {
                if (scope.isEnabled()) {
                    uploadService.promptUserToChooseFile("image/*").then(file => {
                        uploadService.uploadProfileImage(file, scope.userId).then((imagePath) => {
                            let baseImagePath = (($filter as any)("profileImage") as IProfileImageFilter)(scope.userId.toString());
                            scope.ngModel = scope.userId.toString()
                            scope.imgPath = baseImagePath;
                            if (scope.userId == $rootScope.user.id) {
                                $rootScope.$broadcast(events.avatarChanged, scope.ngModel);
                            }
                        }, (e) => {
                            dialogService.alert({
                                msg: loc.msg_uploaderror,
                                type: eAlertType.error
                            });
                        });
                    });
                }
            };
        };
    }
}
